module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n        Search By\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.branchRecordWithchangeFilter
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.planType),
      expression: "form.planType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('planType'),
    },
    attrs: {
      "name": "planType",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "planType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getPlanType]
    }
  }, [(!_vm.form.planType) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                Select plan Type\n              ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "group"
    }
  }, [_vm._v("Group")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "individual"
    }
  }, [_vm._v("Individual")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "planType"
    }
  })], 1), _vm._v(" "), (_vm.form.planType == 'group') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Collection Center ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.collectionCenters,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.changeFilter
    },
    model: {
      value: (_vm.colC),
      callback: function($$v) {
        _vm.colC = $$v
      },
      expression: "colC"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Customer")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": _vm.changeFilterWithCustomer
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "EMI Date"
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "change": function($event) {
        return _vm.changeFilter(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emiStartDate),
      expression: "emiStartDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "EMI Start Date"
    },
    domProps: {
      "value": (_vm.emiStartDate)
    },
    on: {
      "change": function($event) {
        return _vm.changeFilter(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emiStartDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emiEndDate),
      expression: "emiEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "EMI End Date"
    },
    domProps: {
      "value": (_vm.emiEndDate)
    },
    on: {
      "change": function($event) {
        return _vm.changeFilter(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emiEndDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeFilter]
    }
  }, [(!_vm.form.status) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                  Select Status\n                ")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "processing"
    }
  }, [_vm._v("Processing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sattlement"
    }
  }, [_vm._v("Settlement")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "complete"
    }
  }, [_vm._v("Complete")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.canAccess('member-loan-plan-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Loan Reporting ")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('member-loan-plan-create')) ? _c('a', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "href": ((this.$axios.defaults.baseURL) + "/memberloanplan/loansummery/export/excel?emiStartDate=" + _vm.emiStartDate + "&emiEndDate=" + _vm.emiEndDate)
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download Excel\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.memberloanplans), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.applicationNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.member.name) + " (" + _vm._s(row.member.code) + ")")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.alias))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.member.mobile))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.collection_center_id) ? _c('span', [_vm._v(_vm._s(row.collection_center.name) + " (" + _vm._s(row.collection_center.centerCode) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.disbursement.disbursementDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.disbursement.emiStartDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.disbursement.emiEndDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.viewPlanType(row.disbursement)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.getPlanAmt(row.disbursement)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.getDisbursementAmt(row.disbursement)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.totalAmt))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.receivedAmt))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.receivedPanulty))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e(), _vm._v(" "), (row.status == 'processing') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e(), _vm._v(" "), (row.status == 'sattlement') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e(), _vm._v(" "), (row.status == 'complete') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v(_vm._s(row.status))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary btn-xs",
      attrs: {
        "to": /loanDetail/ + row.id + '/' + row.disbursement_id
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }, [_vm._v(" Details")])]), _vm._v(" "), (row.status === 'sattlement' || row.status === 'complete') ? _c('button', {
      staticClass: "btn btn-warning btn-xs",
      on: {
        "click": function($event) {
          return _vm.getNoc(row)
        }
      }
    }, [_vm._v("\n                    NOC\n                  ")]) : _vm._e()], 1)])
  }), 0)])])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('noc', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Status "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("LoanID ")]), _vm._v(" "), _c('th', [_vm._v("Member Name ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Member Alias ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("GroupName")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Disbursment Date")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("EMIStartDate")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("EMIEndDate")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Plan Type")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Plan Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Disb Amt")]), _vm._v(" "), _c('th', [_vm._v("Total Amount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Rec. Amount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Received Penalty")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73df64a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Reports/LoanReport.vue
// module id = 854
// module chunks = 0